export enum AppLayoutType {
  Admin = 'admin', // admin layout
  Blank = 'blank', // no frame
}
